var cov_jl88dsv8o = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tag/index.ts",
      hash = "d38bfa4f4044cc0e47159e8327545aabd0c4d23a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tag/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 21
        },
        end: {
          line: 4,
          column: 24
        }
      },
      "1": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 21
        }
      },
      "2": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 34
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Tag from './Tag';
import Input from './Input';
var Exports = (cov_jl88dsv8o.s[0]++, Tag);
cov_jl88dsv8o.s[1]++;
Exports.Input = Input;
cov_jl88dsv8o.s[2]++;
Exports.displayName = 'ShinoutTag';
export default Exports;